import dayjs from 'dayjs'
import { NewIcon } from '@/components/icon'
import { H1 } from '@/components/label'
import { SummaryButton } from '@/components/summary'
import { isErrorResponse } from '@/types/error'
import { SummaryDetail } from '@/types/summary'
import { UserInfo } from '@/types/user'
import { BookmarkButtons, SubTitle } from './'
import { isFacility } from '@/utils/user'

interface Props {
  userInfo: UserInfo
  summary: SummaryDetail
  bookmark: boolean
  favorite: boolean
}
export const Header: React.FC<Props> = ({
  userInfo,
  summary,
  bookmark,
  favorite,
}) => {
  const weekago = dayjs().subtract(8, 'd')
  const { id, title, subtitle, subpos, released } = summary
  return (
    <div className="flex w-full pc">
      <div className="flex-1"></div>
      <div className="mb-[30px] w-[1024px]">
        <div className="flex justify-between min-w-[1024px]">
          <div className="flex mr-[30px] w-[716px]">
            {dayjs(released).isAfter(weekago) && (
              <NewIcon className="mt-5 mr-3 w-[50px] min-w-[50px] h-[50px] min-h-[50px] text-fl-yellow" />
            )}
            <div>
              {subtitle && subpos === 1 && (
                <SubTitle text={subtitle} className="mt-6" />
              )}
              <H1
                title={title}
                className={`min-h-[50px] text-4xl ${
                  subpos === 2 ? 'mt-5' : ''
                }`}
                showShadowTitle={false}
              />
              {subtitle && subpos === 2 && <SubTitle text={subtitle} />}
            </div>
          </div>
          <div className="text-right">
            <SummaryButton summary={summary} />
            {!isErrorResponse(userInfo) && !isFacility(userInfo?.email) && (
              <BookmarkButtons
                key={id}
                summaryId={id}
                bookmark={bookmark}
                favorite={favorite}
              />
            )}
          </div>
        </div>
        <div className="mt-3 min-w-[1024px] border-b border-[#e6e6e6] border-solid"></div>
      </div>
      <div className="flex-1"></div>
    </div>
  )
}
